export default "__VITE_ASSET__D$sk5Yh9__"